// extracted by mini-css-extract-plugin
export default {"full":"_2xA659BinBviTjVPq-8usr","abbreviated":"_1h0euUXbRG9MyAP-uOzPRN"};